// extracted by mini-css-extract-plugin
export default {"wrapper":"MediaItem_wrapper__GRFiy","item":"MediaItem_item__bxPI3","checkbox":"MediaItem_checkbox__7wB0J","checkboxVisible":"MediaItem_checkboxVisible__LsaTh"};